import React, { useMemo, useState } from "react";
import { PageContainer } from "shared";
import { Form, Loader, SectionContent } from "components";
import { AppBar } from "@mui/material";
import { changePhoneForm } from "utils/constants";
import { updateTranePhoneSchema } from "utils/formSchema";
import PasswordDialog from "components/PasswordDialog";
import { useGetAirtimeToCashPhoneNumber } from "api/actions/transactionKap";
import UpdatePhoneComponent from "./components/UpdatePhoneComponent";
import UpdatePhoneHistory from "./components/UpdatePhoneHistory";

export default function UpdatePhone() {
  const { isSubmitting, updatePhone, phoneNumber, isFetching, refetchPhone } =
    useGetAirtimeToCashPhoneNumber();

  const [updatedPhone, setUpdatedPhone] = useState(phoneNumber);
  const [reconfirm, setReconfirm] = useState(false);
  const [getPassField, setPassField] = useState({
    password: "",
  });

  const handleChangedPhone = (e) => {
    setUpdatedPhone(e.target.value);
  };
  const initialFieldValues = useMemo(() => {
    return {
      updatePhoneNumber: phoneNumber,
    };
  }, [phoneNumber]);

  const handleRefetch = async () => {
    setReconfirm(false);
    await refetchPhone();
  };
  const handleUpdatePhone = async () => {
    await updatePhone({
      password: getPassField.password,
      phoneNumber: updatedPhone,
      changedFrom: phoneNumber,
      // update phone number UI
      callback: handleRefetch,
    });
    // reset password field
    setPassField({ password: "" });
  };
  return (
    <PageContainer>
      <div className="p-3 bg-white rounded dark:bg-gray-900">
        <AppBar
          sx={{ position: "sticky" }}
          classes={{
            root: "h-16 bg-gradient-to-r from-bg_gradient_from to-bg_gradient_to shadow !sticky flex flex-row justify-center p-6 !z-[900] dark:from-dark_bg_gradient_from dark:to-dark_bg_gradient_from",
          }}
        >
          <div className="text-lg font-semibold">
            Update Airtime to Cash Phone Number
          </div>
        </AppBar>
        {!isFetching ? (
          <SectionContent>
            <div className="p-2 rounded bg-box shadow-card-box dark:bg-gray-800">
              <div className="col-span-1">
                <div className="w-full p-2 border rounded shadow-sm border-slate-100 bg-box dark:border-slate-700 dark:bg-gray-900">
                  <div className="mb-6 font-semibold dark:text-white">
                    Update Phone Number
                  </div>
                  <div className="flow-root">
                    <Form
                      fieldList={changePhoneForm}
                      initialFieldValues={initialFieldValues}
                      buttonText="Update Phone"
                      disableVisibilty={true}
                      useValidateOnChange
                      validationSchema={updateTranePhoneSchema}
                      handleChange={handleChangedPhone}
                      extraInfoWithProps={({
                        values,
                        isValid,
                        setFieldValue,
                      }) => (
                        <UpdatePhoneComponent
                          isValid={isValid}
                          values={values}
                          setFieldValue={setFieldValue}
                          phoneNumber={phoneNumber}
                          setReconfirm={setReconfirm}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <UpdatePhoneHistory />
          </SectionContent>
        ) : (
          <div className="relative flex items-center justify-center w-full h-40 p-6 rounded bg-box shadow-card-box dark:bg-gray-900">
            <Loader />
          </div>
        )}
      </div>
      <PasswordDialog
        {...{
          title: "Update Airtime To Cash Phone Number",
          buttonLabel: "Update Phone",
          open: reconfirm,
          setOpen: setReconfirm,
          getField: getPassField,
          setField: setPassField,
          isSubmitting: isSubmitting,
          handleClick: handleUpdatePhone,
        }}
      />
    </PageContainer>
  );
}
